import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';

const Mall = (props) => {
  const { user } = props;
  const { siteId } = useParams();
  const [mallData, setMallData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();

  const [values, setValues] = useState({
    mall_id: null,
    mall_name: '',
    point_limit: 0,
    ratio_mall: 0,
    ratio_shop: 0,
    terms_title: '',
    terms: '',
    mall_code: '',
  });

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    const mallData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setMallData(mallData);
  }, [siteId]);

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      mall_id: null,
      mall_name: '',
      point_limit: 0,
      ratio_mall: 0,
      ratio_shop: 0,
      terms_title: '',
      terms: '',
      mall_code: '',
    });
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.mall_name) {
      window.alert('施設名を入力してください。');
      return;
    }
    if (data.mall_name.length > 100) {
      window.alert('施設名は、100文字以内で入力してください。');
      return;
    }
    if (!String(data.point_limit)) {
      window.alert('ポイント上限を入力してください。');
      return;
    }
    if (!(String(data.point_limit)).match(/^[0-9]+$/)) {
      window.alert('ポイント上限は正の半角整数で入力してください。');
      return;
    }
    if (!String(data.ratio_mall)) {
      window.alert('負担割合（施設）を入力してください。');
      return;
    }
    if (!(String(data.ratio_mall)).match(/^[0-9]+$/)) {
      window.alert('負担割合（施設）は正の半角整数で入力してください。');
      return;
    }
    if (!String(data.ratio_shop)) {
      window.alert('負担割合（店舗）を入力してください。');
      return;
    }
    if (!(String(data.ratio_shop)).match(/^[0-9]+$/)) {
      window.alert('負担割合（店舗）は正の半角整数で入力してください。');
      return;
    }
    if (data.mall_code && data.mall_code.length > 40) {
      window.alert('施設コードは、40文字以内で入力してください。');
      return;
    }

    var params = data;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;

    let res;
    try {
      setLockData(true);
      if (params.mall_id === null || params.mall_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mall/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/mall/${params.mall_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`施設[${data.mall_id}:${data.mall_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      mall_id: data.mall_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mall/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.mall_name === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.mall_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-60`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    var value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>施設ID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="mall_id" defaultValue={values.mall_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
          <label htmlFor="mall_name">施設名</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" id="mall_name" name="mall_name" value={values.mall_name} onChange={handleChange} placeholder="施設名を入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="point_limit">ポイント上限</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <input type="text" className="form-control" id="point_limit" name="point_limit" value={values.point_limit} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ratio_mall">負担割合（施設）</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <input type="text" className="form-control" id="ratio_mall" name="ratio_mall" value={values.ratio_mall} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="ratio_shop">負担割合（店舗）</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <input type="text" className="form-control" id="ratio_shop" name="ratio_shop" value={values.ratio_shop} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="terms_title">利用規約タイトル</label>
          </div>
          <div className="col-5 align-self-center">
            <textarea className="form-control" rows="3" name="terms_title" id="terms_title" value={values.terms_title} onChange={handleChange}></textarea>
          </div>
          <div className="col-5 text-left align-self-center">
            タイトルは&lt;h4&gt;タグで囲んでください。<br />
            例: <br /><code>&lt;h4&gt;タイトル&lt;/h4&gt;</code>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="terms">利用規約内容</label>
          </div>
          <div className="col-5 align-self-center">
            <textarea className="form-control" rows="5" name="terms" id="terms" value={values.terms} onChange={handleChange}></textarea>
          </div>
          <div className="col-5 text-left align-self-center">
            見出しは&lt;h5&gt;タグで囲んでください。<br />
            改行を行う場合は&lt;br /&gt;タグを挿入してください。<br />
            例: <br /><code>&lt;h5&gt;1. 目的&lt;/h5&gt;アプリの目的について記載します。&lt;br /&gt;&lt;h5&gt;2. サービス利用資格&lt;/h5&gt;サービス利用資格についての説明を記載します。&lt;br /&gt;&lt;h5&gt;3. アプリの内容&lt;/h5&gt;アプリの内容について記載します。</code>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="mall_code">施設コード</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <input type="text" className="form-control" id="mall_code" name="mall_code" value={values.mall_code} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-2 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-2 text-center">
            {renderResetButton(values)}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    return (
      <div className="row mb-3 p-0">
        <div className="col-12 mb-1 p-0 text-right">
        </div>
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  施設ID
                </td>
                <td className="text-center align-middle">
                  施設名
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {mallData.map((data, idx) => (
                <tr key={data.mall_id}>
                  {/* 施設ID */}
                  <td className="text-center align-middle">
                    {data.mall_id}
                  </td>
                  {/* 施設名 */}
                  <td className="text-center align-middle">
                    {data.mall_name}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // const renderPreview = () => {
  //   return (
  //     <div className="modal" id="exampleModal">
  //       <div className="modal-dialog preview-modal">
  //         <div className="modal-content">
  //           <div className="modal-header">
  //             <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setSelectData(null)}><span aria-hidden="true">&times;</span></button>
  //           </div>
  //           <div className="modal-body">
  //             {(ticketData && !selectData) &&
  //               <TicketList
  //                 ticket_list={ticketData}
  //                 ticketClick={(id) => () => setSelectData({ ...ticketData.find(t => t.ticket_id === id), t_ticket_use: [] })}
  //                 siteId={siteId}
  //                 setting={setting}
  //               />
  //             }
  //             {selectData &&
  //               <LiffTicket
  //                 ticket={selectData}
  //                 ticketClick={(id) => () => { }}
  //                 backClick={() => setSelectData(null)}
  //                 disabled={lockData}
  //                 siteId={siteId}
  //               />
  //             }
  //           </div>
  //           <div className="modal-footer">
  //             <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => setSelectData(null)}>Close</button>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="container">
      {mallData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {mallData !== null && (renderList())}
      {renderInput()}
      {/* {renderPreview()} */}
    </div>
  )
}

export default Mall;